import Loading from '@cobliteam/ui/components/Loading';
import colors from '@cobliteam/ui/theme/tokens/colors';

const DropdownOverlayLoading = () => (
  <div className='flex h-52 items-center justify-center px-5'>
    <Loading fill={colors.gray.DEFAULT} />
  </div>
);

export default DropdownOverlayLoading;
